import { UUID } from '@nova/types';

/** Shared prefix for GES multiplayer Socket.IO rooms (`SocketMpEngine.joinRooms`). */
function mpMatchRoomBase(matchId: UUID): string {
  return `m-${matchId}::`;
}

/** Room for every socket in a match (match-wide broadcasts). */
export function getMpMatchAllRoomKey(matchId: UUID): string {
  return `${mpMatchRoomBase(matchId)}all`;
}

/** Room for all peers on one team in a match. */
export function getMpMatchTeamRoomKey(matchId: UUID, teamId: number): string {
  return `${mpMatchRoomBase(matchId)}t-${teamId}`;
}
